export default "__VITE_ASSET__Bx986pTs__"